<div class="login-page">
  <app-topnav [pageName]="pageName" [llttfPage]="llttfPage"></app-topnav>

  <div class="container">
    <div class="content" role="main">
      <div class="cmha-dashboard">
        <div class="participant-banner" [ngClass]="bannerClass">
          <div class="container">
            <h2>{{ mandatoryRemaining > 0 ? 'Required role training' : 'Optional role training' }}</h2>
            @if (current) {
              <span class="onboarding-training__banner-intro">
                @if (current.isMandatory) {
                  You must watch and acknowledge the training for
                  <strong>{{ current.roleName }}</strong>
                  before you can use the portal.
                } @else {
                  This training for <strong>{{ current.roleName }}</strong> is optional. You can complete it now or skip it.
                }
                @if (pending.length > 1) {
                  {{ mandatoryRemaining }} required and {{ optionalRemaining }} optional courses remaining.
                }
              </span>
            }
          </div>
        </div>
        <div class="h-30"></div>

        <div class="container">
          @if (current) {
            <h3 class="onboarding-training__course-title">{{ current.title }} <small>({{ current.isMandatory ? 'Required' : 'Optional' }})</small></h3>
            @if (current.description) {
              <p class="onboarding-training__description">{{ current.description }}</p>
            }

            <div class="onboarding-training__player" aria-label="Training video">
              @if ((embedType === 'youtube' || embedType === 'vimeo' || embedType === 'iframe') && safeEmbedUrl) {
                <iframe
                  [src]="safeEmbedUrl"
                  title="Role training video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
              }
              @if (embedType === 'video' && videoSrc) {
                <video [src]="videoSrc" controls></video>
              }
            </div>

            <div class="onboarding-training__ack">
              <mat-checkbox [(ngModel)]="acknowledged" name="acknowledged">
                I acknowledge that I have watched and completed this training.
              </mat-checkbox>
            </div>

            <div class="form-buttons">
              <button
                class="submit-form-button"
                type="button"
                [disabled]="!acknowledged || isSubmitting"
                (click)="submit()">
                Complete training
              </button>
              @if (!current.isMandatory) {
                <button
                  class="submit-form-button cancel-button"
                  type="button"
                  [disabled]="isSubmitting"
                  (click)="skip()">
                  Skip for now
                </button>
              }
            </div>
          }
        </div>

        <div class="h-30"></div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
